.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 1rem;
  text-align: center;
}

.heading {
  margin: 0 0 1rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
}

.subtitle {
  margin: 0 0 2rem;
  font-size: 1rem;
  color: #555;
  max-width: 480px;
  line-height: 1.5;
}

.button {
  padding: 0.5rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #fff;
  background-color: #0077c2;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
}
